import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '../../atoms/menuItem/menuItem';
import Button from '../../atoms/button/button';

const Menu = (props) => {
  const {
    children, vertical, center, right, className,
  } = props;

  return (
    <nav className={className}>
      <ul className={`nav ${vertical ? 'flex-column' : ''} ${center ? 'justify-content-center' : ''} ${right ? 'justify-content-end' : ''}`}>
        {children}
      </ul>
    </nav>
  );
};

Menu.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any.isRequired,
  vertical: PropTypes.bool,
  center: PropTypes.bool,
  right: PropTypes.bool,
  className: PropTypes.string,
};

Menu.defaultProps = {
  vertical: false,
  center: false,
  right: false,
  className: '',
};

export default Menu;
